export default "__VITE_ASSET__d8dd68ac__"